/*
 * @创建文件时间: 2019-10-29 16:01:23
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-30 21:21:38
 * @联系Qq:1638245306
 * @文件介绍: 全局过滤器
 */
import Tools from "@/plugin/Tools";
import { start } from "nprogress";

/**
 * 声明表格桩号过滤器
 */
export function stakeTableFilter(value) {
    if (value == "0") {
        return "K0+000"
    } else if (value != undefined) {
        let reg = new RegExp("^K.*?");
        value = (value * 1.000).toFixed(3)
        if (reg.test(value)) {
            value = value.slice(1, -4) + value.slice(-3)
        } else {
            let arry = value.split('.')
            value = 'K' + arry[0] + '+' + arry[1]
        }
    }
    return value
}

/**
 * 桩号表单过滤
 */
export function stakeFormFilter(value) {
    let num = value ? ((value * 1.000).toFixed(3)) : '0.000'
    let _str = ''
    if (num < 0) {
        num = num * (-1)
    }
    if (num == '' || num == null) {
        num = 0
    }
    let val = num.toString()
    let arry = val.split('.');
    let last = arry[1]
    return "K" + arry[0] + '+' + last.toString()
}

export function BTCstakeFilter(value) {
    let num = value ? ((value * 1.000).toFixed(5)) : '0.00000'
    let _str = ''
    if (num < 0) {
        num = num * (-1)
    }
    if (num == '' || num == null) {
        num = 0
    }
    let val = num.toString()
    let arry = val.split('.');
    let last = arry[1]
    if (typeof last === 'string' && last.length > 3) {
        last = `${last.substring(0,3)}.${last.substring(3)}`
    }

    return "K" + arry[0] + '+' + last.toString()
}

/**
 * 时间过滤日期
 */
export function dateFilter(value) {
    let val = value == null ? "" : value;
    return val.substr(0, 10);
}
/**
 * 时间过滤月份
 */
export function monthFilter(value) {
    let val = value == null ? "" : value;
    return val.substr(0, 7);
}
/**
 * 时间过滤年份
 */
export function yearFilter(value) {
    let val = value == null ? "" : value;
    return val.substr(0, 4);
}

/**
 * 月作业计划展示时间
 */
export function monthToTimeFilter(value) {
    if (!value || value == null) {
        return ""
    } else {
        let monDate = new Date(value);
        let startDay = 21;
        let startMonth = monDate.getMonth() == 0 ? 12 : monDate.getMonth();
        let startYear = monDate.getMonth() == 0 ? (monDate.getFullYear() - 1) : monDate.getFullYear();
        let endDay = 20;
        let endMonth = monDate.getMonth() + 1;
        let endYear = monDate.getFullYear();
        let val = startYear + "-" + startMonth + "-" + startDay + "|" + endYear + "-" + endMonth + "-" + endDay;
        return val;
    }

}

/**
 * 断链长度过滤器
 * @param {值} value 
 */
export function chainLength(value) {
    let num = (value / 1000).toFixed(3)
    return num
}


/**
 * 时间过滤月份
 */
export function personDataFilter(value) {
    let val = value + "";
    if (!val || val == null || val == "null") {
        return ""
    } else {
        let valuexs = ""
        if (val.indexOf('00:00:00') >= 0) {
            valuexs = val.substr(0, 10);
        } else {
            valuexs = val;
        }
        return valuexs;
    }

}

export function stateTypeFilter(type) {
    let value = '';
    if (type == "1") {
        value = "在职";
    } else if (type == "4") {
        value = "精简下放";
    } else if (type == "2") {
        value = "离休";
    } else if (type == "3") {
        value = "退休";
    } else if (type == "5") {
        value = "遗属供养";
    } else {}
    return value
}


export function isEdcFilter(type) {
    let value = '';
    if (type == "1") {
        value = "在职学历";
    } else if (type == "0") {
        value = "全日制学历";
    } else {}
    return value
}

// 计量数字校验
export function paymentNum(num) {
    let value
    if (num && (num > 0)) { value = num } else { value = "" }
    return value
}